export default "__VITE_ASSET__f85f8b6b__"